import React from 'react';
import {Route, Switch, Redirect} from 'react-router-dom';

import Candidates from './components/Candidates'
import Candidate from './components/Candidate';
import Heatmap from './components/Heatmap';
import Hiring_Zones from "./components/Hiring_Zones"

import ErrorBoundaryRoute from '../../../../containers/ErrorBoundaryRoute';
import SchedulesComponent from "./components/HiringSchedules";

/*
	First is exact Route XYZ/
	Second is sub page(s) XYZ/ABC
	Third is sub page(s) with IDs XYZ/ABC/ID
	Last is non exact with ID. XYZ/ID
	Final is a redirect
 */
export default ({match, regions,roles}) => (
	<div>
		<Switch>
			<ErrorBoundaryRoute exact path={`${match.url}/heatmap`}>
				<Heatmap regions={regions} roles={roles} filter={2}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/reach_out`}>
				<Candidates regions={regions} roles={roles} filter={2} route={'reach_out'} prettyName={'Reach Out'}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/pre_interview`}>
				<Candidates regions={regions} roles={roles} filter={3} route={'pre_interview'} prettyName={'Pre-Interview'}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/scheduled_interview`}>
				<Candidates regions={regions} roles={roles} filter={4} route={'scheduled_interview'} prettyName={'Scheduled Interview'}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/interviews`}>
				<Candidates regions={regions} roles={roles} filter={5} route={'interviews'} prettyName={'Interviews'}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/offered_job`}>
				<Candidates regions={regions} roles={roles} filter={10} route={'offered_job'} prettyName={'Offered Job'}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/paperwork`}>
				<Candidates regions={regions} roles={roles} filter={11} route={'paperwork'} prettyName={'Paperwork'}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/hired`}>
				<Candidates regions={regions} roles={roles} filter={12} route={'hired'} prettyName={'Hired'}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/actively`}>
				<Candidates regions={regions} roles={roles} filter={13} route={'actively'} prettyName={'Actively Working'}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/declined`}>
				<Candidates regions={regions} roles={roles} filter={14} route={'declined'} prettyName={'ServiceBookr Declined'}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/quit`}>
				<Candidates regions={regions} roles={roles} filter={15} route={'quit'} prettyName={'Quit'}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/hold`}>
				<Candidates regions={regions} roles={roles} filter={16} route={'hold'} prettyName={'On Hold'}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/search`}>
				<Candidates regions={regions} roles={roles} filter={'search'} route={'search'} prettyName={'Candidate Search'}/>
			</ErrorBoundaryRoute>
			<ErrorBoundaryRoute path={`${match.url}/hiringschedules`}>
				<SchedulesComponent regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute path={`${match.url}/candidates/:id`}>
				<Candidate regions={regions} baseUrl={match.url} roles={roles}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/hiring_zones`}>
				<Hiring_Zones regions={regions} roles={roles}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute>
				<Redirect to={`${match.url}`}/>
			</ErrorBoundaryRoute>
		</Switch>
	</div>
);
